module.exports = __webpack_public_path__ + "static/media/empty-cart.9f98023a.svg";